import { t } from "../../translations";
import "../styles/terms-services.css";

const CommunityGuidelines = ({ lang }) => {
  return (
    <div className="servicesTerms_body">
      <h1>{t("community_guidelines.page_title", lang)}</h1>

      <p>{t("community_guidelines.intro", lang)}</p>

      <h2 className="h2-title">
        {t("community_guidelines.safety_guidelines_title", lang)}
      </h2>
      <ul>
        <li>{t("community_guidelines.safety_guideline_1", lang)}</li>
        <li>{t("community_guidelines.safety_guideline_2", lang)}</li>
        <li>{t("community_guidelines.safety_guideline_3", lang)}</li>
        <li>{t("community_guidelines.safety_guideline_4", lang)}</li>
        <li>{t("community_guidelines.safety_guideline_5", lang)}</li>
      </ul>

      <h2 className="h2-title">
        {t("community_guidelines.menu_planning_title", lang)}
      </h2>
      <ul>
        <li>{t("community_guidelines.menu_guideline_1", lang)}</li>
        <li>{t("community_guidelines.menu_guideline_2", lang)}</li>
        <li>{t("community_guidelines.menu_guideline_3", lang)}</li>
        <li>{t("community_guidelines.menu_guideline_4", lang)}</li>
        <li>{t("community_guidelines.menu_guideline_5", lang)}</li>
        <li>{t("community_guidelines.menu_guideline_6", lang)}</li>
        <li>{t("community_guidelines.menu_guideline_7", lang)}</li>
        <li>
          {t("community_guidelines.menu_guideline_8", lang)}
          <ul>
            <li>{t("community_guidelines.menu_info_1", lang)}</li>
            <li>{t("community_guidelines.menu_info_2", lang)}</li>
            <li>{t("community_guidelines.menu_info_3", lang)}</li>
            <li>{t("community_guidelines.menu_info_4", lang)}</li>
            <li>{t("community_guidelines.menu_info_5", lang)}</li>
          </ul>
        </li>
      </ul>

      <h2 className="h2-title">
        {t("community_guidelines.supplies_title", lang)}
      </h2>
      <ul>
        <li>{t("community_guidelines.supplies_guideline_1", lang)}</li>
        <li>{t("community_guidelines.supplies_guideline_2", lang)}</li>
        <li>{t("community_guidelines.supplies_guideline_3", lang)}</li>
      </ul>

      <h2 className="h2-title">
        {t("community_guidelines.media_release_title", lang)}
      </h2>
      <p>{t("community_guidelines.media_release_text", lang)}</p>

      <h2 className="h2-title">
        {t("community_guidelines.continuing_provisions_title", lang)}
      </h2>
      <p>{t("community_guidelines.continuing_provisions_text", lang)}</p>

      <h2 className="h2-title">
        {t("community_guidelines.amendments_title", lang)}
      </h2>
      <p>{t("community_guidelines.amendments_text", lang)}</p>

      <h2 className="h2-title">
        {t("community_guidelines.violations_title", lang)}
      </h2>
      <p>{t("community_guidelines.violations_text", lang)}</p>

      <p>
        <strong>{t("community_guidelines.last_revised", lang)}</strong>
      </p>
    </div>
  );
};

export default CommunityGuidelines;
